import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, inject } from '@angular/core';

@Component({
    selector: 'tran-pill-header-cell',
    template: '<ng-content></ng-content>',
    host: {
        class: 'flex items-start gap-1 md:gap-2'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillHeaderCellComponent implements AfterViewInit {
    private elementRef = inject(ElementRef);

    @HostBinding('class') hostClasses = 'w-full md:flex-1 pr-1 md:pr-0';

    ngAfterViewInit(): void {
        const isFirst = this.elementRef.nativeElement.previousElementSibling === null;
        if (!isFirst) {
            this.hostClasses = 'w-full md:flex-1 md:-ml-4 pl-4 md:pl-10 pr-1 md:pr-0';
        }
    }
}
